import type { ComponentProps } from 'react';
import React, { useState } from 'react';
import UserDetailPreview from './UserDetailPreview';
import * as styles from './UserDetailPreviewPopOver.module.scss';
import FloatingCard from '../components/FloatingCard';
import HoverView from '../components/HoverView';

interface UserDetailPreviewPopOverProps
  extends Pick<ComponentProps<typeof HoverView>, 'placement' | 'hoverDelay'> {
  userId: string;
  children: React.ReactNode;
}

const UserDetailPreviewPopOver = ({
  userId,
  children,
  placement,
  hoverDelay,
}: UserDetailPreviewPopOverProps) => {
  const [minHeight, setMinHeight] = useState<number | null>(null);

  return (
    <HoverView
      placement={placement}
      hoverGroupId="userDetailPreview"
      hoverDelay={hoverDelay}
      view={
        <FloatingCard
          className={styles.view}
          style={minHeight ? { minHeight } : { visibility: 'hidden' }}
        >
          <UserDetailPreview userId={userId} setMinHeight={setMinHeight} />
        </FloatingCard>
      }
    >
      {children}
    </HoverView>
  );
};

export default UserDetailPreviewPopOver;
